var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.18238 0C0.529503 0 -0.00012207 0.5135 -0.00012207 1.14612V14.8542C-0.00012207 15.4869 0.529565 16 1.18238 16H14.8174C15.4705 16 15.9999 15.4869 15.9999 14.8541V1.14612C15.9999 0.5135 15.4705 0 14.8174 0H1.18238ZM4.86211 6.18673V13.39H2.46786V6.18673H4.86211ZM5.01992 3.95904C5.01992 4.65029 4.50023 5.20342 3.66548 5.20342L3.66529 5.20336H3.64979C2.84623 5.20336 2.32673 4.65023 2.32673 3.95898C2.32673 3.25204 2.86192 2.71436 3.68136 2.71436C4.50023 2.71436 5.00429 3.25204 5.01992 3.95904ZM8.58142 13.39H6.18736L6.18729 13.3902C6.18729 13.3902 6.21873 6.86273 6.18748 6.18698H8.58161V7.20657C8.89987 6.71585 9.46947 6.01786 10.7394 6.01786C12.3146 6.01786 13.4956 7.04742 13.4956 9.25986V13.39H11.1016V9.53685C11.1016 8.56842 10.7549 7.90792 9.88879 7.90792C9.22723 7.90792 8.83329 8.35336 8.66029 8.78367C8.59704 8.93723 8.58142 9.15279 8.58142 9.36779V13.39Z",
    fill: "#BED000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoin);
export default __webpack_public_path__ + "static/media/logoin.090c58f1802d3ac163ff4466ac4696c7.svg";
export { ForwardRef as ReactComponent };